import { Dispatch } from 'react';
import { IconArrowsSort, IconSortAscending, IconSortDescending } from '@tabler/icons';
import { ActionIcon } from '@mantine/core';
import { actionTypes } from '../../../../types';
import useFilterStyles from './useFilterStyles';

function getSortIcon(key: any) {
  switch (key?.value) {
    case 'asc':
      return IconSortAscending;
    case 'desc':
      return IconSortDescending;
    default:
      return IconArrowsSort;
  }
}

export default function SortFilter({
  orderBy,
  state,
  dispatch,
}: {
  orderBy: string;
  state: any;
  dispatch: Dispatch<any>;
}) {
  const filter = (state?.sorts || []).find((_filter: any) => _filter.property === orderBy);
  const { classes } = useFilterStyles({
    isFilterEnabled: filter?.value === 'asc' || filter?.value === 'desc',
  });

  const SortIcon = getSortIcon(filter);

  const handleClick = () => {
    if (filter?.value === 'desc') {
      dispatch({ type: actionTypes.SET_SORT, payload: { property: orderBy, value: '' } });
    } else {
      dispatch({
        type: actionTypes.SET_SORT,
        payload: { property: orderBy, value: filter?.value === 'asc' ? 'desc' : 'asc' },
      });
    }
  };

  return (
    <ActionIcon
      size="sm"
      className={classes.filterIconButton}
      color={filter?.value ? 'blue' : 'gray'}
      onClick={handleClick}
      variant="filled"
    >
      <SortIcon size={16} stroke={1.5} />
    </ActionIcon>
  );
}
